var _path, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightfulChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 3 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49264 6.22901C3.68575 7.04751 1.8348 9.32918 1.61983 12.2356C1.48456 14.0646 2.12181 15.7704 3.51459 17.3073C3.91975 17.7544 4.36796 18.3488 4.51051 18.6281C4.86522 19.3235 5.15146 20.4783 5.15146 21.2142V22.942C5.15146 24.0466 6.04689 24.942 7.15146 24.942H8.19874H9.27957C10.371 24.942 11.2608 24.0671 11.2793 22.9759L11.316 20.8043C11.4061 19.4907 11.8628 18.499 12.9309 17.2984C14.9816 14.9933 15.4001 12.3803 14.1428 9.73063C13.6317 8.65361 12.4503 7.38281 11.4727 6.85873C9.94649 6.04048 7.98837 5.79294 6.49264 6.22901Z",
    stroke: "#2962FF",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.21802,
    y1: 20.8593,
    x2: 11.2363,
    y2: 20.8593,
    stroke: "#2962FF",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.98399,
    y1: 3.39053,
    x2: 2.99911,
    y2: 4.62228,
    stroke: "#2962FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 2.34615,
    y2: -0.75,
    transform: "matrix(-0.635983 0.771703 0.771703 0.635983 15.5325 3.2879)",
    stroke: "#2962FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 2.34615,
    y2: -0.75,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 8.7019 0.928497)",
    stroke: "#2962FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightfulChecked);
export default __webpack_public_path__ + "static/media/insightful_checked.c44861245f0a24dbb5220d992de56011.svg";
export { ForwardRef as ReactComponent };